import { chat } from "@/lib/http";
import type {
  SearchRequest, SearchResultPage, GroupedSearchResult,
  AccountScope, SearchPage,
  ChatHit, ChannelHit, PersonHit, MessageHit, LinkHit,
} from "./types";

export function searchChat(
  req: SearchRequest,
): Promise<SearchResultPage | GroupedSearchResult> {
  const body: Record<string, unknown> = { account_id: req.account_id, text: req.text };
  if (req.conversation_id !== undefined && req.conversation_id !== null) body.conversation_id = req.conversation_id;
  if (req.cursor !== undefined && req.cursor !== null) body.cursor = req.cursor;
  if (req.limit !== undefined) body.limit = req.limit;
  return chat<SearchResultPage | GroupedSearchResult>("/v1/chat/search", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

// ---------------------------------------------------------------------------
// Search v2 — per-tab API client functions
// ---------------------------------------------------------------------------

interface V2Body {
  account_scope: AccountScope;
  text: string;
  cursor?: string | null;
  limit?: number;
}

function buildV2Body(
  scope: AccountScope,
  text: string,
  cursor?: string | null,
  limit?: number,
): V2Body {
  const b: V2Body = { account_scope: scope, text };
  if (cursor !== undefined && cursor !== null) b.cursor = cursor;
  if (limit !== undefined) b.limit = limit;
  return b;
}

export function searchChats(
  scope: AccountScope,
  text: string,
  cursor?: string | null,
  limit?: number,
): Promise<SearchPage<ChatHit>> {
  return chat<SearchPage<ChatHit>>("/v1/chat/search/chats", {
    method: "POST",
    body: JSON.stringify(buildV2Body(scope, text, cursor, limit)),
  });
}

export function searchChannels(
  scope: AccountScope,
  text: string,
  cursor?: string | null,
  limit?: number,
): Promise<SearchPage<ChannelHit>> {
  return chat<SearchPage<ChannelHit>>("/v1/chat/search/channels", {
    method: "POST",
    body: JSON.stringify(buildV2Body(scope, text, cursor, limit)),
  });
}

export function searchPeople(
  scope: AccountScope,
  text: string,
  cursor?: string | null,
  limit?: number,
): Promise<SearchPage<PersonHit>> {
  return chat<SearchPage<PersonHit>>("/v1/chat/search/people", {
    method: "POST",
    body: JSON.stringify(buildV2Body(scope, text, cursor, limit)),
  });
}

export function searchMessagesGlobal(
  scope: AccountScope,
  text: string,
  cursor?: string | null,
  limit?: number,
): Promise<SearchPage<MessageHit>> {
  return chat<SearchPage<MessageHit>>("/v1/chat/search/messages", {
    method: "POST",
    body: JSON.stringify(buildV2Body(scope, text, cursor, limit)),
  });
}

export function searchLinks(
  scope: AccountScope,
  text: string,
  cursor?: string | null,
  limit?: number,
): Promise<SearchPage<LinkHit>> {
  return chat<SearchPage<LinkHit>>("/v1/chat/search/links", {
    method: "POST",
    body: JSON.stringify(buildV2Body(scope, text, cursor, limit)),
  });
}
